jQuery(document).ready(function($) {
    // Existing footer form handler
    $('.footer__form form').on('submit', function(e) {
        e.preventDefault();
        
        const $form = $(this);
        const $submit = $form.find('button[type="submit"]');
        const $feedback = $form.find('.footer__input-group-error');
        const originalText = $submit.text();
        
        // Clear previous messages and set sending state
        $feedback.removeClass('footer__error footer__success').empty();
        $submit.prop('disabled', true)
               .text('Sending...');
        
        $.ajax({
            url: ibNewsletter.ajaxurl,
            type: 'POST',
            data: {
                action: 'newsletter_signup',
                newsletter_email: $form.find('input[name="newsletter_email"]').val(),
                newsletter_nonce: ibNewsletter.nonce,
                privacy_consent: $form.find('input[name="privacy_consent"]').is(':checked')
            },
            success: function(response) {
                if (response.success) {
                    $feedback.addClass('footer__success').html(response.data);
                    $form.find('input[type="email"], input[type="checkbox"]').prop('disabled', true);
                    $submit.prop('disabled', true)
                           .text('Sent')
                           .addClass('sent');
                } else {
                    $feedback.addClass('footer__error').html(response.data);
                    $submit.prop('disabled', false).text(originalText);
                }
            },
            error: function(xhr, status, error) {
                console.error("AJAX Error:", status, error);
                $feedback.addClass('footer__error').html('Something went wrong. Please try again.');
                $submit.prop('disabled', false).text(originalText);
            }
        });
    });
    
    // Single post newsletter form handler
    $('.single-post__content-newsletter-form').on('submit', function(e) {
        e.preventDefault();
        
        const $form = $(this);
        const $submit = $form.find('button[type="submit"]');
        const $feedback = $form.find('.single-post__content-newsletter-feedback');
        const originalText = $submit.find('.button-text').text();
        
        // Clear previous messages and set sending state
        $feedback.removeClass('success error').empty();
        $submit.prop('disabled', true);
        $submit.find('.button-text').text('Sending...');
        
        $.ajax({
            url: ibNewsletter.ajaxurl,
            type: 'POST',
            data: {
                action: 'newsletter_signup',
                newsletter_email: $form.find('input[name="newsletter_email"]').val(),
                newsletter_nonce: ibNewsletter.nonce,
                privacy_consent: true // Assume consent on single post form
            },
            success: function(response) {
                if (response.success) {
                    $feedback.addClass('success').html(response.data);
                    $form.find('input[type="email"]').prop('disabled', true);
                    $submit.prop('disabled', true);
                    $submit.find('.button-text').text('Sent');
                } else {
                    $feedback.addClass('error').html(response.data);
                    $submit.prop('disabled', false);
                    $submit.find('.button-text').text(originalText);
                }
            },
            error: function(xhr, status, error) {
                console.error("AJAX Error:", status, error);
                $feedback.addClass('error').html('Something went wrong. Please try again.');
                $submit.prop('disabled', false);
                $submit.find('.button-text').text(originalText);
            }
        });
    });
});